<template>
  <security-page>
    <template #left>
      <page-illustration :src="illustration" />
    </template>
    <template #right>
      <register-form />
    </template>
  </security-page>
</template>

<script>
import SecurityPage from "@/views/security/components/SecurityPage.vue";
import PageIllustration from "@/views/security/components/PageIllustration.vue";
import RegisterForm from "@/views/security/components/RegisterForm.vue";

export default {
  components: {
    SecurityPage,
    PageIllustration,
    RegisterForm,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      illustration: require("@/assets/images/illustrations/new-user.svg"),
    };
  },
};
</script>
